import { queryOptions, useQuery } from '@tanstack/react-query';

import { apiClient } from '@cast/infrastructure-api';

import { useOrganizations } from '@cast/shared-organization-context-data-access';

const APA_COMPLIANCE_FIX_REPORT_QUERY_KEY = 'apa-compliance-fix-report';

const getComplianceFixReportQueryKey = (organizationId?: string) =>
  [APA_COMPLIANCE_FIX_REPORT_QUERY_KEY, organizationId] as const;

const getComplianceFixReportQueryOptions = ({
  organizationId,
}: {
  organizationId?: string;
}) =>
  queryOptions({
    queryKey: getComplianceFixReportQueryKey(organizationId),
    queryFn: async () => {
      if (!organizationId) {
        throw new Error('organizationId is required');
      }
      const { data } = await apiClient.apa.getComplianceFixReport({
        organizationId,
      });
      return data;
    },
    enabled: !!organizationId,
  });

export const useComplianceFixReportQuery = () => {
  const { currentOrganization } = useOrganizations();

  const { isLoading, data, error, refetch } = useQuery(
    getComplianceFixReportQueryOptions({
      organizationId: currentOrganization?.id,
    })
  );

  return {
    isLoading,
    data,
    error,
    refetch,
  };
};
